import React from 'react';

const PostSubmitModal = ({ serverMessage }) => {
    const getModalTitle = () => {
        if (serverMessage && (serverMessage.includes('Approved') || serverMessage.includes('Conditioned') || serverMessage.includes('AD') || serverMessage.includes('Declined'))) {
            return 'You have received a response from our underwriting team.';
        } else if (serverMessage && serverMessage.includes('Rehash')) {
            return 'We need a little more time to give your application the attention it deserves. We will contact you shortly.';
        } else {
            return 'Rehash submitted. We are now reviewing your application and giving it the attention you deserve.';
        }
    };

    return (
        <div className="modal fade" id="post_submit_modal" tabIndex={-1} role="dialog" aria-labelledby="post_submit_modal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <img src="/images/green-check-mark.png" alt="check" style={{ marginLeft: '35px', marginRight: '15px' }} width="100px" />
                        <h6 className="modal-title">
                            {getModalTitle()}
                        </h6>
                    </div>
                    {serverMessage && (serverMessage.includes('Approved') || serverMessage.includes('Conditioned') || serverMessage.includes('AD') || serverMessage.includes('Declined')) ?
                        <div className="modal-body text-center">Close this dialog box to view the response.</div> : null}
                    <div className="modal-footer">
                        <button className="btn btn-primary" type="button" data-bs-dismiss="modal">OK</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(PostSubmitModal);
